import React, { useCallback } from "react";
import { DetailedAlert } from "../../../components/DetailedAlert";
import { adminApi as api } from "../../../util/api";
import { snakifyKeys } from "../../../util/helpers";
import { ImportModal } from "../../components/ImportModal";

export const ImportClinicLabsModal = ({ clinicId, onImport, ...rest }) => {
  const handleImport = useCallback(
    async (values) => {
      const params = {
        clinic: clinicId,
        file: {
          bytes: values.file,
        },
      };
      const res = await api.post(`/admin/clinic_lab_permissions/import.json`, snakifyKeys(params));

      onImport?.(res.data?.meta?.message, res.data?.meta?.error_details);
    },
    [onImport, clinicId]
  );

  return (
    <ImportModal
      buttonProps={rest}
      onImport={handleImport}
      title="Import Labs..."
      exampleDownloadPath="/admin/clinic_lab_permissions/example"
    ></ImportModal>
  );
};
